import { useStringConstants } from "@/app/hooks/useStringConstants";
import clsx from "clsx";
import { startCase } from "lodash";

const CustomerMembership: React.FC<{
  membershipStatus: boolean;
  className?: string;
}> = (props) => {
  const { customerMemberText, customerNonMemberText } = useStringConstants();
  return (
    <span className={clsx(props?.className)}>
      {props?.membershipStatus ? startCase(customerMemberText) : startCase(customerNonMemberText)}
    </span>
  );
};

export default CustomerMembership;
